import { createSelector } from 'reselect';

const selectProfilePage = state => state.profilePage;

export const selectVisible = createSelector(
    [selectProfilePage],
    profilePage => profilePage.visible
);
